import React, { Component } from 'react';

class NoMatch extends Component {
  render () {
    return <p>No Route Found</p>;
  }
}

export default NoMatch;
